import { useMemo } from 'react';

import { LocationsGeoFilterInput } from '@ocx/graphql';

import { Offer, SanitizedLocation } from './offer.types';
import { sanitizeAvailableAtLocations } from './offer.dto';
import { useOffers } from './use-offers.hook';

export type UseOfferParams = {
  offerId: string;
  locationsGeoFilter?: LocationsGeoFilterInput;
};

export type OfferWithSanitizedLocations = Omit<Offer, 'availableAtLocations'> & {
  availableAtLocations: SanitizedLocation[];
};

export const useOffer = ({ offerId, locationsGeoFilter }: UseOfferParams) => {
  const { offers, loading } = useOffers({
    variables: {
      first: 1,
      idEquals: offerId,
      locationsGeoFilter: locationsGeoFilter ?? null,
      deleted: false,
      offerLimitsIncluded: true,
      offerVouchersIncluded: true,
      constraintsIncluded: true,
      availableAtLocationsIncluded: true,
    },
  });

  const offer: OfferWithSanitizedLocations | null = useMemo(() => {
    if (!offers.length) {
      return null;
    }
    return {
      ...offers[0],
      availableAtLocations: sanitizeAvailableAtLocations(offers[0].availableAtLocations),
    };
  }, [offers]);

  return { offer, loading };
};
